import { SnackbarOrigin } from 'notistack';

type SnackbarProps = {
  anchorOrigin: SnackbarOrigin;
  autoHideDuration: number;
};

const isProduction = process.env.NODE_ENV === 'production';

export const HlsConfig = {
  fragLoadingTimeOut: 10000,
  debug: !isProduction,
  // startPosition: 1000,
};

export const SnackbarConfig: SnackbarProps = {
  anchorOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  autoHideDuration: 5000,
};
